import { Pipe, PipeTransform } from '@angular/core';

import { customerShareIndicadores } from '../customer-share-indicador';

@Pipe({
    name: 'customerShareIndicadorColor'
})
export class CustomerShareIndicadorColorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = customerShareIndicadores.findIndex(indicador => indicador.id === value);
        if (index > -1) {
            return customerShareIndicadores[index].color;
        }
        return '';
    }
}
